import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Translation, TranslocoScope } from '@ngneat/transloco';
import { firstValueFrom, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

/**
 * Create a scope loader for translations stored at /assets/i18n/{scope}/{lang}.json
 * This matches the structure: /assets/i18n/main-editor/en.json
 */
export function createFolderScopeLoader(scope: string) {
  return {
    scope,
    loader: {
      'en': async () => {
        const startTime = performance.now();
        const http = inject(HttpClient);
        const path = `/assets/i18n/${scope}/en.json`;
        console.log(`[FolderScopeLoader] START Loading: ${path} at ${startTime.toFixed(0)}ms`);

        return firstValueFrom(
          http.get<Translation>(path).pipe(
            tap(data => {
              console.log(`[FolderScopeLoader] DONE ${scope}/en after ${(performance.now() - startTime).toFixed(0)}ms`);
            }),
            catchError((error) => {
              console.error(`[FolderScopeLoader] FAILED ${path} after ${(performance.now() - startTime).toFixed(0)}ms:`, error);
              return of({});
            })
          )
        );
      },
      'he-IL': async () => {
        const startTime = performance.now();
        const http = inject(HttpClient);
        const path = `/assets/i18n/${scope}/he-IL.json`;
        console.log(`[FolderScopeLoader] START Loading: ${path} at ${startTime.toFixed(0)}ms`);

        return firstValueFrom(
          http.get<Translation>(path).pipe(
            tap(data => {
              console.log(`[FolderScopeLoader] DONE ${scope}/he-IL after ${(performance.now() - startTime).toFixed(0)}ms`);
            }),
            catchError((error) => {
              console.error(`[FolderScopeLoader] FAILED ${path} after ${(performance.now() - startTime).toFixed(0)}ms:`, error);
              return of({});
            })
          )
        );
      }
    }
  };
}
